const _ = require('lodash')

const GetImagePathList = function() {
    let result = [
        // ['wall' ,           require("@/components/pixi/assets/wall.png")],
        // ['imgBgGreen',      require("@/game/assets/bg-green.png")],
        // ['imgBgOrange',     require("@/game/assets/bg-orange.png")],
        // ['imgBgYellow',     require("@/game/assets/bg-yellow.png")],

        // ['imgP1Logo',       require("@/game/assets/p1-title/logo.png")],
        // ['imgP1Title',      require("@/game/assets/p1-title/title.png")],

        // ['imgP2Start',      require("@/game/assets/p2-intro/start.png")],
        // ['imgP2Textbox',    require("@/game/assets/p2-intro/textbox.png")],
        // ['imgP2Title',      require("@/game/assets/p2-intro/title.png")],

        // ['imgP3Avatar',     require("@/game/assets/p3-playerinfo/avatar.png")],
        // ['imgP3Next',       require("@/game/assets/p3-playerinfo/next.png")],

        // ['imgP4Player1',    require("@/game/assets/p4-player/player1.png")],
        // ['imgP4Player2',    require("@/game/assets/p4-player/player2.png")],
        // ['imgP4Player3',    require("@/game/assets/p4-player/player3.png")],

        // ['imgP5Kitchen',    require("@/game/assets/p5-kitchen/bg-kitchen.png")],
        // ['imgP5Basket',     require("@/game/assets/p5-kitchen/basket-icon.png")],
        // ['imgP5Add',        require("@/game/assets/p5-kitchen/bubble/add.png")],
        // ['imgP5Close',      require("@/game/assets/p5-kitchen/bubble/x-icon.png")],
        // ['imgP5SumBox',     require("@/game/assets/p5-kitchen/bubble/summarybox.png")],
        // ['imgP5Trash',      require("@/game/assets/p5-kitchen/bubble/trash-icon.png")],
        // ['imgP5TimeUp',     require("@/game/assets/p5-kitchen/bubble/timesup.png")],

        // ['imgP6Next',       require("@/game/assets/p6-summary/next.png")],
        // ['imgP6Scale',      require("@/game/assets/p6-summary/scale.png")],
        // ['imgP6TextBox',    require("@/game/assets/p6-summary/textbox2.png")],

        // ['imgP7PlayAgain',  require("@/game/assets/p7-result/playagain.png")],
        // ['imgP7Player1',    require("@/game/assets/p7-result/player1-p7.png")],
        // ['imgP7Player2',    require("@/game/assets/p7-result/player2-p7.png")],
        // ['imgP7Player3',    require("@/game/assets/p7-result/player3-p7.png")],
        // ['imgP7Textbox',    require("@/game/assets/p7-result/textbox3.png")],

        // ['imgP7FB',    require("@/game/assets/p7-result/fb.png")],
        // ['imgP7Line',    require("@/game/assets/p7-result/line.png")],
        // ['imgP7Twitter',    require("@/game/assets/p7-result/twitter.png")],

        ['imgP1Bowl',    require("@/game/assets/01 02/01 02_big bowl.png")],
        ['imgP1Title',    require("@/game/assets/01 02/01 02_title.png")],
        ['imgP1Salad',    require("@/game/assets/01 02/01 02_salad.png")],
        ['imgP1Star',    require("@/game/assets/01 02/01 02_star.png")],
        ['imgP1Water',    require("@/game/assets/01 02/01 02_water.png")],
        ['imgP1Start',    require("@/game/assets/01 02/01_start.png")],
        ['imgP1Logo',    require("@/game/assets/01 02/logo.png")],
        
        ['imgP2Question',    require("@/game/assets/01 02/01 02_question.png")],
        ['imgP2Choice1',    require("@/game/assets/01 02/01 02_choice1.png")],
        ['imgP2Choice2',    require("@/game/assets/01 02/01 02_choice2.png")],

        ['imgP3Calendar',    require("@/game/assets/03/03_calender.png")],
        ['imgP3Choice1',    require("@/game/assets/03/03_choice1.png")],
        ['imgP3Choice2',    require("@/game/assets/03/03_choice2.png")],
        ['imgP3Choice3',    require("@/game/assets/03/03_choice3.png")],
        ['imgP3Choice4',    require("@/game/assets/03/03_choice4.png")],
        ['imgP3Pen',        require("@/game/assets/03/03_pen.png")],
        ['imgP3PostIt',    require("@/game/assets/03/03_post it.png")],
        ['imgP3Question',    require("@/game/assets/03/03_question.png")],
        ['imgP3Star1',    require("@/game/assets/03/03_star 1.png")],
        ['imgP3Star2',    require("@/game/assets/03/03_star 2.png")],

        ['imgP4Choice1',    require("@/game/assets/04/04_choice1.png")],
        ['imgP4Choice2',    require("@/game/assets/04/04_choice2.png")],
        ['imgP4Choice3',    require("@/game/assets/04/04_choice3.png")],
        ['imgP4Choice4',    require("@/game/assets/04/04_choice4.png")],
        ['imgP4Veg',    require("@/game/assets/04/04_more veg.png")],
        ['imgP4Question',    require("@/game/assets/04/04_question.png")],
        ['imgP4Spoon',    require("@/game/assets/04/04_veg spoon.png")],

        ['imgP5Broccoli',    require("@/game/assets/05/05_broccoli.png")],
        ['imgP5Bullets',    require("@/game/assets/05/05_bullets.png")],
        ['imgP5Carrot',    require("@/game/assets/05/05_carrot.png")],
        ['imgP5Choices',    require("@/game/assets/05/05_choices.png")],
        ['imgP5Garnish1',    require("@/game/assets/05/05_garnish 1.png")],
        ['imgP5Garnish2',    require("@/game/assets/05/05_garnish 2.png")],
        ['imgP5GarnishStar',    require("@/game/assets/05/05_garnish star FOR LANDSCAPE.png")],
        ['imgP5Leafy',    require("@/game/assets/05/05_leafy.png")],
        ['imgP5Paper',    require("@/game/assets/05/05_paper.png")],
        ['imgP5Question',    require("@/game/assets/05/05_question.png")],
        ['imgP5Tomato',    require("@/game/assets/05/05_tomato.png")],
        ['imgP5TomatoFlipped',    require("@/game/assets/05/05_tomanto FLIPPED.png")],
        ['imgP5Check',    require("@/game/assets/05/05_check.png")],
        ['imgP5Next',    require("@/game/assets/05/05_next.png")],
        ['imgP5Multiple',    require("@/game/assets/05/05_multiple.png")],

        ['imgP6Choice1',    require("@/game/assets/06/06_choice 1.png")],
        ['imgP6Choice2',    require("@/game/assets/06/06_choice 2.png")],
        ['imgP6Question',    require("@/game/assets/06/06_question.png")],
        ['imgP6Plate',    require("@/game/assets/06/06_apple orage plate.png")],
        ['imgP6Banana',    require("@/game/assets/06/06_banana.png")],
        ['imgP6Garnish',    require("@/game/assets/06/06_garnish.png")],
        ['imgP6Watermelon',    require("@/game/assets/06/06_watermelon.png")],

        ['imgP7Choice1',    require("@/game/assets/07/07_choice 1.png")],
        ['imgP7Choice2',    require("@/game/assets/07/07_choice 2.png")],
        ['imgP7Choice3',    require("@/game/assets/07/07_choice 3.png")],
        ['imgP7Choice4',    require("@/game/assets/07/07_choice 4.png")],
        ['imgP7Question',   require("@/game/assets/07/07_question.png")],
        ['imgP7Pen',        require("@/game/assets/07/07_pen.png")],
        ['imgP7Agenda',    require("@/game/assets/07/07_agenda.png")],

        ['imgP8BGPortrait',   require("@/game/assets/08/08_white bg PORTRAIT.png")],
        ['imgP8BGLandscape',   require("@/game/assets/08/08_white bg LANDSCAPE.png")],
        ['imgP8Choice1',    require("@/game/assets/08/08_choice 1.png")],
        ['imgP8Choice2',    require("@/game/assets/08/08_choice 2.png")],
        ['imgP8Choice3',    require("@/game/assets/08/08_choice 3.png")],
        ['imgP8Choice4',    require("@/game/assets/08/08_choice 4.png")],
        ['imgP8Question',   require("@/game/assets/08/08_question.png")],
        ['imgP8Banana',   require("@/game/assets/08/08_banana.png")],
        ['imgP8Orange',   require("@/game/assets/08/08_orange.png")],
        ['imgP8Mango',   require("@/game/assets/08/08_mango.png")],
        ['imgP8Grape',   require("@/game/assets/08/08_grape.png")],
        ['imgP8Rambutan',   require("@/game/assets/08/08_rambutan.png")],
        ['imgP8List1',   require("@/game/assets/08/08_fruit list 1.png")],
        ['imgP8List2',   require("@/game/assets/08/08_fruit list 2.png")],

        ['imgP9Choice1',    require("@/game/assets/09/09_choice 1.png")],
        ['imgP9Choice2',    require("@/game/assets/09/09_choice 2.png")],
        ['imgP9Choice3',    require("@/game/assets/09/09_choice 3.png")],
        ['imgP9Choice4',    require("@/game/assets/09/09_choice 4.png")],
        ['imgP9Question',   require("@/game/assets/09/09_question.png")],
        ['imgP9Fruits',    require("@/game/assets/09/09_fruit tote.png")],
        ['imgP9Garnish',    require("@/game/assets/09/09_garnish.png")],
        
        ['imgP10FramePortrait',    require("@/game/assets/10 11 12 13/10 11 12 13 FRAME_Portrait.png")],
        ['imgP10Result1Portrait',    require("@/game/assets/10 11 12 13/10 PORTRAIT.png")],
        ['imgP10Result2Portrait',    require("@/game/assets/10 11 12 13/11 PORTRAIT.png")],
        ['imgP10Result3Portrait',    require("@/game/assets/10 11 12 13/12 PORTRAIT.png")],
        ['imgP10Result4Portrait',    require("@/game/assets/10 11 12 13/13 PORTRAIT.png")],

        ['imgP10Result1LandScape',    require("@/game/assets/10 11 12 13/10 LANDSCAPE.png")],
        ['imgP10Result2LandScape',    require("@/game/assets/10 11 12 13/11 LANDSCAPE.png")],
        ['imgP10Result3LandScape',    require("@/game/assets/10 11 12 13/12 LANDSCAPE.png")],
        ['imgP10Result4LandScape',    require("@/game/assets/10 11 12 13/13 LANDSCAPE.png")],

        ['imgP10Replay',    require("@/game/assets/10 11 12 13/10_11_12_13_replay.png")],
    ]

    // for(let i = 1; i <= 40; ++i) {
    //     let paddedNum = ("00" + i).substr(-2,2)
    //     result.push([
    //         'veggieIcon' + i,
    //         require("@/game/assets/p5-kitchen/veggie-icon/" + paddedNum + ".png")
    //     ])
    //     result.push([
    //         'veggieDetail' + i,
    //         require("@/game/assets/p5-kitchen/veggie+detail/" + paddedNum + ".png")
    //     ])
    // }

    return result
}

export default {
    load: function(PIXI, app, callback) {        

        app.loader
            .add(
                _
                .chain(GetImagePathList())
                .map((elem) => {
                    return elem[1]
                })
                .value()
            )
            .load((loader, resources) => {
                let textureMap = {}
                
                _
                .chain(GetImagePathList())
                .forEach((elem) => {
                    textureMap[ elem[0] ] = {
                        path: elem[1],
                        texture: resources[ elem[1] ].texture,
                    }
                })
                .value()

                return callback(textureMap, resources)
            })
    },
}